module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/quote@2x.29054c8f.jpg";